import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { FooterComponent } from './layout/footer/footer.component';
import { PaymentsComponent } from './stripe/payments.component';
import { NotFoundComponent } from './home/notfound.component';
import { GrowlModule } from 'primeng/growl';
import { PaymentsService } from './stripe/payments.service';
import { ProcessingComponent } from './processing/processing.component';
import { ProcessingService } from './processing/processing.service';
import { ProductsService } from './products/products.service';
import { ProductsComponent } from './products/list/products.component';
import { DetailComponent } from './products/detail/detail.component';
import { LoginComponent } from './home/login/login.component';
import { AuthGuard } from './_guard/auth.guard';
import { AuthenticationService } from './_shared/authentication.service';
import { PayHttpInterceptor } from './_shared/interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LogoutComponent } from './home/logout/logout/logout.component';
import { HeaderComponent } from './layout/header/header.component';
import { MessageComponent } from './layout/message/message.component';
import { MessageService } from './layout/message/message.service';
import { ConfirmationService } from 'primeng/api';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


@NgModule({
	declarations: [
		NotFoundComponent,
		ProductsComponent,
		PaymentsComponent,
		AppComponent,
		FooterComponent,
		ProcessingComponent,
		DetailComponent,
		LoginComponent,
		LogoutComponent,
		HeaderComponent,
		MessageComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		FormsModule,
		GrowlModule,
		NgbModule.forRoot(),
		ConfirmDialogModule,
		RouterModule.forRoot([
			{
				path: 'products',
				component: ProductsComponent,
				canActivate: [AuthGuard],
			},
			{
				path: 'products/:id',
				component: DetailComponent,
				canActivate: [AuthGuard],
			},
			{ path: 'processing/:id', component: ProcessingComponent },
			{ path: 'processing/participants/:uid', component: ProcessingComponent },
			{ path: 'processing/:id/:uid', component: ProcessingComponent },
			{ path: 'payment/:transaction', component: PaymentsComponent },
			{ path: 'payments/:description/:amount/:product', component: PaymentsComponent },
			{ path: 'payments', component: NotFoundComponent },
			{ path: 'admin/login', component: LoginComponent },
			{ path: 'logout', component: LogoutComponent },
			{
				path: '',
				redirectTo: 'admin/login',
				pathMatch: 'full',
				canActivate: [AuthGuard],
			},
			{ path: '**', redirectTo: 'admin/login', pathMatch: 'full' },
		]),
	],
	providers: [
		ProcessingService,
		PaymentsService,
		ProductsService,
		MessageService,
		ConfirmationService,
		AuthGuard,
		AuthenticationService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: PayHttpInterceptor,
			multi: true,

		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
